var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page mb-2"},[_c('h2',[_vm._v("Feedback de la empresa")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.companyInterviewFeedback))])])
}
var staticRenderFns = []

export { render, staticRenderFns }